/**
 * @file document-totals.ts
 * @description Итоги строки реестра складского документа (phase19.31, зона
 * «Склад»): число позиций, сумма количеств и строка «3 позиции · 12 шт» для
 * компактного списка. Чистые функции — отдельно от ячеек-компонентов.
 */

import { pluralRu } from "../../../lib/plural";
import { formatQuantity, sumQuantity, type QuantityRow } from "../../../lib/wms-doc-totals";

/** Число позиций документа. */
export function positionsCount(items: readonly QuantityRow[] | undefined): number {
  return items?.length ?? 0;
}

/** Сумма количеств документа: «12». */
export function quantityTotal(items: readonly QuantityRow[] | undefined): string {
  return formatQuantity(sumQuantity(items));
}

/** «3 позиции · 12 шт» — итог для строки компактного списка. */
export function totalsLine(items: readonly QuantityRow[] | undefined): string {
  const count = positionsCount(items);
  return `${count} ${pluralRu(count, ["позиция", "позиции", "позиций"])} · ${quantityTotal(items)} шт`;
}
